import React from 'react';
import type { TimelineLayer, SceneObject } from '../../types';
import { getRootObjects } from '../../util/sceneObjectHierarchy';

interface StageLayerProps {
  layer: TimelineLayer;
  objects: SceneObject[];
  renderObject: (obj: SceneObject) => React.ReactNode;
  zIndex: number;
  /** Bust React.memo when selection chrome (quick menu / handles) must refresh. */
  selectionKey?: string;
}

export const StageLayer = React.memo(function StageLayer({ layer, objects, renderObject, zIndex }: StageLayerProps) {
  const roots = getRootObjects(objects);

  return (
    <div
      className={`stage-layer ${!layer.visible ? 'hidden' : ''} ${layer.locked ? 'locked' : ''}`}
      data-layer-id={layer.id}
      style={{ zIndex }}
    >
      {roots.map((obj) => (
        <React.Fragment key={obj.id}>{renderObject(obj)}</React.Fragment>
      ))}
    </div>
  );
});
